// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"F7-z"};